export default __webpack_public_path__ + "static/media/diamond-color-table@2x.4100120a.png";